import System from './System';
import GameObject from '../GameObject/GameObject';
import { Anim, AwaitIterators, GetAnimationClip, PlayAnimation } from './Animation/AnimationHelper';
import { SceneTransition } from '../Scene/SceneManager';
import RelativePositionComponent from '../Component/Render/RelativePosition';
import Point from '../Utility/Point';
import Game from '../Game';
import Text from '../Prototype/Text';
import Container from '../Prototype/Container';
import AnimationComponent from '../Component/Animation';
import Sprite from '../Prototype/Sprite';
import { AnimationClipEvent } from './Animation/AnimationClip';
import { GameActions } from '../State/Game/GameActions';
import { AsyncActionStatus } from '../State/AsyncAction';
import { IGameState } from '../State/Game/IGameState';
import { scaleSpriteToScreen } from 'Utility/LevelHelper';
import { generifyPromise } from 'Utility/async';
import { setIsTransitioning } from 'Utility/isTransitioning';
import { FarmLoadingScreen } from 'Prototype/Effect/FarmLoadingScreen';
import { FARM_BUTTON_NAME } from 'Prefabs/UI/HUD/FarmButton';

export default class FarmTransitionSystem extends System {
    public static LOADING_ANIMATION: string = 'loading_animation';
    public static LOADING_OVERLAY: string = 'loading_overlay';
    public static LOADING_BACKGROUND: string = 'loading_background';
    public container: Container;
    public background: Sprite;
    public transitionComplete: boolean = false;
    private loading: FarmLoadingScreen;

    public onStart(): void {
        this.scene.on(SceneTransition.START, () => {
            this.startCoroutine(this.transitionIn());
        });

        this.scene.on(SceneTransition.END, () => {
            this.startCoroutine(this.transitionOut());
        });
    }
    private *transitionIn() {
        try {
            this.transitionComplete = false;
            this.createObjects();
            yield* AwaitIterators([
                PlayAnimation(
                    GetAnimationClip('ContainerFadeIn', this.container, {
                        startAlpha: 0,
                        endAlpha: 1,
                        duration: 300,
                    })
                        .on(AnimationClipEvent.DESTROY, this.transitionInComplete.bind(this, false))
                        .on(AnimationClipEvent.COMPLETE, this.transitionInComplete.bind(this, true))
                ),
                this.loading.animate(),
            ]);
        } catch (e) {
            console.error(e);
        }
    }
    private transitionInComplete(success: boolean): void {
        if (this.transitionComplete) return;
        if (success) {
            //Game.scene.getActiveScene().stop();
            this.scene.emit(SceneTransition.STARTED);
        } else {
            const state: IGameState = Game.store.getState();
            GameActions.setState({
                ...state,
                activeScene: {
                    ...state.activeScene,
                    status: AsyncActionStatus.QUEUED,
                },
            });
        }
        this.transitionComplete = true;
    }
    private *transitionOut() {
        this.loading.stopAnimation();
        yield* generifyPromise(Anim(this.container, { alpha: 0, duration: 1000 }));
        this.scene.emit(SceneTransition.ENDED);
        this.destroyObjects();
        setIsTransitioning(false);

        // this.scene.stop();
        this.scene.unload();
    }
    private createObjects() {
        this.container = GameObject.Instantiate(Container, {
            name: 'PreloaderContainer',
            alpha: 0,
        });
        this.container.addComponent(RelativePositionComponent, {
            relativePosition: new Point(0.5, 0.5),
        });

        this.container.addComponent(AnimationComponent);
        this.background = GameObject.Instantiate(Sprite, {
            name: FarmTransitionSystem.LOADING_BACKGROUND,
            texture: 'my_farm_bg',
            anchor: new Point(0.5, 0.5),
        });

        scaleSpriteToScreen(this.background);

        const farmButtonIcon = GameObject.Instantiate(Sprite, {
            name: 'farmButtonLoading',
            texture: 'my_farm_icon',
            anchor: new Point(0.5, 0.5),
            x: 0,
            y: 300,
        });

        this.loading = GameObject.Instantiate(FarmLoadingScreen, {});

        this.container.addChild(this.background);
        this.container.addChild(this.loading);
        // this.container.addChild(farmButtonIcon);

        this.scene.addGameObject(this.container);
    }
    private destroyObjects() {
        this.container.destroy();
    }

    public handleStateChanged(state: IGameState): void {}
    public init(params?: any): void {}
    protected onUpdate(): void {}
    protected onLateUpdate(): void {}
    protected onStop(): void {}
    protected onDestroy(): void {}
    public async preload(): Promise<any> {
        return undefined;
    }
}
